import { useBankOverviewSearchParams } from './useBankOverviewSearchParams';
import { useTransactionsFilters } from './useTransactionsFilters';

export const useShouldMergeIntraCompanyFundsTransfers = () => {
  const { filters } = useTransactionsFilters();
  const { bankAccountId } = useBankOverviewSearchParams();

  const isFilteredByPayinOrPayout = filters.payin || filters.payout;

  return !bankAccountId && !isFilteredByPayinOrPayout;
};
